import { render, staticRenderFns } from "./OnRoad.vue?vue&type=template&id=290b829f&scoped=true"
import script from "./OnRoad.vue?vue&type=script&lang=js"
export * from "./OnRoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290b829f",
  null
  
)

export default component.exports